import { posthog } from 'posthog-js';
import { watch } from 'vue';

import { useUser } from './use-user';

export function usePostHog() {
  const user = useUser();

  function identifyUser() {
    if (!posthog.__loaded || !user.id.value) return;

    posthog.identify(String(user.id.value), {
      email: user.email.value,
      name: user.fullName.value,
    });

    if (user.tenantId.value) {
      posthog.group('company', String(user.tenantId.value), {
        name: user.tenantName.value,
      });
    }
  }

  function resetPostHog() {
    if (!posthog.__loaded) return;
    posthog.reset();
  }

  watch(
    () => user.user.value,
    (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        if (oldVal) {
          resetPostHog();
        }
        identifyUser();
      } else if (!newVal && oldVal) {
        resetPostHog();
      }
    }
  );
}
